<template>
  <div>
    <!--    <el-button type="text" @click="dialogVisible = true">点击打开 Dialog</el-button>-->

    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="800px"
        >
      <div>
        <el-form inline size="mini" @submit.native.p.prevent>
          <el-form-item>
            <el-select
                v-model="userSelected"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="用户昵称姓名查询"
                :remote-method="remoteMethod"
                :loading="loading" clearable>
              <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-plus" @click="handleToTable('Y')" title="点击添加到分组：《查看全部数据》">查看全部数据</el-button>
            <el-button type="primary" icon="el-icon-plus" @click="handleToTable('N')" title="点击添加到分组：《查看自己数据》，该成员自能看到自己的关联客户数据">仅看自己数据</el-button>
          </el-form-item>
          <el-form-item>
            <div>
              <el-tooltip content="成员只能加入1个分组，即加入的《查看全部数据》，就不能加入到《查看自己数据》；反之亦然" placement="bottom" effect="light">
                <el-button type="text"><span class="el-icon-info" style="color: #fe346e"></span></el-button>
              </el-tooltip>

            </div>
          </el-form-item>
        </el-form>
        <div class="flex-justify-sb">
          <div class="box" v-loading="loadingList"
               element-loading-text="加载中……"
               element-loading-spinner="el-icon-loading">
            <h3>查看全部数据
              <el-button type="text" icon="el-icon-refresh" @click="handleQuery" :loading="loadingList"
                         :disabled="loadingList"></el-button>
            </h3>
            <el-table :data="dataListAll" height="400" border>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="name" label="姓名" width="120" align="center"></el-table-column>
              <el-table-column label="操作" width="110" align="center">
                <template slot-scope="{row}">
                  <el-link type="danger" icon="el-icon-delete" @click="handleRemove(row,'Y')">移除</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="box" v-loading="loadingList"
               element-loading-text="加载中……"
               element-loading-spinner="el-icon-loading">
            <h3>仅看自己数据
              <el-button type="text" icon="el-icon-refresh" @click="handleQuery" :loading="loadingList"
                         :disabled="loadingList"></el-button>
            </h3>
            <el-table :data="dataListSelf" height="400" border>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="name" label="姓名" width="120" align="center"></el-table-column>
              <el-table-column label="操作" width="110" align="center">
                <template slot-scope="{row}">
                  <el-link type="danger" icon="el-icon-delete" @click="handleRemove(row,'N')">移除</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

<!--      <div slot="footer" class="dialog-footer">-->
<!--        <el-button @click="dialogVisible = false">取 消</el-button>-->
<!--        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
<!--      </div>-->
    </el-dialog>
  </div>
</template>

<script>
import {
  addScopeKeyCustomer,
  listScopeKeyCustomer,
  removeScopeKeyCustomer,
  searchUserKeyCustomer
} from "@/api/profileCustomer";

export default {
  name: "DialogScope",
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '设置查看权限',
      loading: false,
      loadingList: false,
      options: [],
      userSelected: [],
      keyCustomerObj: {id: null, title: null},
      // formData: {user_id: null, name: '', scope_all: "N"},
      dataListAll: [],
      dataListSelf: []
    };
  },
  methods: {
    show(keyCustomerObj) {
      this.keyCustomerObj = keyCustomerObj
      this.dialogTitle = `【${this.keyCustomerObj.title}】设置查看权限`
      this.dialogVisible = true
      this.handleQuery()
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          // eslint-disable-next-line no-unused-vars
          .then(_ => {
            done();
          })
          // eslint-disable-next-line no-unused-vars
          .catch(_ => {
          });
    },
    async handleSearchUser(keyword) {
      //search_user
      let {data} = await searchUserKeyCustomer(keyword)
      return data || []
    },
    async handleQuery() {
      this.loadingList = true
      this.dataListAll = [];
      this.dataListSelf = [];
      let {data: {list}} = await listScopeKeyCustomer({key_customer_id: this.keyCustomerObj.id})
      if (list) {
        list.forEach((item) => {
          if (item.scope_all === 'Y')
            this.dataListAll.push(item)
          else if (item.scope_all === 'N') {
            this.dataListSelf.push(item)
          }
        })
      }
      setTimeout(() => {
        this.loadingList = false
      }, 200)

    },
    /**
     * 检测唯一
     * @param row
     * @returns {number}
     */
    checkUq(row) {
      let posIndex = this.dataListAll.findIndex(value => value.user_id === row.user_id)
      if (posIndex > -1) {
        this.$message.warning('成员已加入到《查看全部数据》')
        return posIndex
      } else {
        let posIndex = this.dataListSelf.findIndex(value => value.user_id === row.user_id)
        if (posIndex > -1) {
          this.$message.warning('成员已加入到《查看自己数据》')
        }
      }
      return posIndex;
    },
    handleToTable(scope_all) {
      this.userSelected.forEach((user_id) => {
        let user = this.options.find(value => value.id === user_id)
        let postData = {
          key_customer_id: this.keyCustomerObj.id,
          scope_all: scope_all,
          user_id: user_id,
          name: user.name || null,
        }
        //若已存在，则限制提交
        let posIndex = this.checkUq(postData)
        if (posIndex > -1)
          return

        this.handleSave(postData)
      })
    },
    async handleSave(postData) {
      //发起网络请求
      let data = await addScopeKeyCustomer(postData)
      if (data.success) {
        if (postData.scope_all === 'Y') {
          this.dataListAll.push(postData)
        } else if (postData.scope_all === "N") {
          this.dataListSelf.push(postData)
        } else {
          this.$message.warning("无效类型")
        }
      }
    },

    // eslint-disable-next-line no-unused-vars
    handleRemove(row, scope_all) {

      if (scope_all === 'Y') {
        let posIndex = this.dataListAll.findIndex(value => value.user_id === row.user_id)
        let removeRow = this.dataListAll.splice(posIndex, 1)

        let removedId = removeRow[0].id || null
        if (removedId)
          removeScopeKeyCustomer(removedId)
      } else if (scope_all === "N") {
        let posIndex = this.dataListSelf.findIndex(value => value.user_id === row.user_id)
        let removeRow = this.dataListSelf.splice(posIndex, 1)
        let removedId = removeRow[0].id || null
        if (removedId)
          removeScopeKeyCustomer(removedId)

      } else {
        this.$message.warning("无效类型")
      }
    },
    async remoteMethod(query) {
      if (query !== '') {
        this.loading = true;

        this.options = await this.handleSearchUser(query)
        // eslint-disable-next-line no-console
        console.log('options', this.options)
        this.loading = false;

      } else {
        this.options = [];
      }
    }
  }
}
</script>

<style scoped>
.box {
  border: 1px solid #e6e6e6;
  padding: 2px;
  text-align: center;
}
</style>
